/**
 * Basic Style Constants
 *
 * Reusable Tailwind class strings for consistent styling across the app
 */

// Layout
export const CONTAINER_STYLES = "container mx-auto px-4";
export const SECTION_STYLES = "py-20";

// Colors
export const ACCENT_TEXT = "text-blue-900 dark:text-blue-500";
export const ACCENT_BG = "bg-blue-50 dark:bg-blue-900/20";
export const GRAY_BG = "bg-gray-50 dark:bg-gray-900/20";

// Typography
export const HEADING_STYLES = "mb-4 font-heading text-3xl font-extrabold md:text-4xl " + ACCENT_TEXT;
export const SUBHEADING_STYLES = "mx-auto max-w-2xl text-lg text-gray-500 dark:text-gray-400";

// Buttons
export const BUTTON = "bg-transparent hover:bg-blue-900 text-gray-900 hover:text-white border border-gray-900 hover:border-blue-900 dark:bg-transparent dark:hover:bg-blue-500 dark:text-white dark:hover:text-white dark:border dark:border-white dark:hover:border-blue-500";
export const BUTTON_ACCENT = "text-white hover:text-white bg-blue-500 stroke-white hover:bg-blue-900 border border-blue-500 hover:border-blue-900 dark:bg-blue-900 dark:text-white dark:hover:bg-blue-500 dark:border dark:border-blue-900 dark:hover:border-blue-500";

// Cards
export const CARD = "rounded-lg border-transparent bg-white dark:bg-gray-800 text-gray-900 dark:text-white shadow-xl ring ring-gray-900/5";
export const CARD_HOVER = "hover:shadow-elegant hover:-translate-y-1 transition-all duration-300";

// Icons
export const ICON = "bg-blue-100 dark:bg-blue-900 text-blue-900 dark:text-white";
